import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {IntegrationTypeModel} from '../../../../../models/api/integrationTypesModel';
import {AppState} from '../../../../../store/appState';
import {
  getCompanyHasHiddenBilling,
  getIsBilledThroughOtherCompany,
} from '../../../../../store/data/company/companySelectors';
import {
  getIsAtMaxEnabledIntegrationLimit,
  makeGetIsIntegrationAvailableOnPlan,
  makeGetIsIntegrationUncounted,
} from '../../../../../store/data/integrations/integrationSelectors';
import {getIsUserGlobalAdmin} from '../../../../../store/data/teammates/teammatesSelectors';
import {SettingsAppsDetailsUpsellBanner} from './settingsAppsDetailsUpsellBanner';

/*
 * Props.
 */

interface SettingsAppsDetailsUpsellBannerContainerProps {
  integrationType: IntegrationTypeModel;
}

/*
 * Selectors.
 */

function getIntegrationId(_state: AppState, props: SettingsAppsDetailsUpsellBannerContainerProps) {
  return props.integrationType.id;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAppsDetailsUpsellBannerContainerProps>()(() => ({
  isIntegrationAvailableOnPlan: makeGetIsIntegrationAvailableOnPlan(getIntegrationId),
  isIntegrationUncounted: makeGetIsIntegrationUncounted(getIntegrationId),
  isAtMaxEnabledIntegrationLimit: getIsAtMaxEnabledIntegrationLimit,
  isBillingHidden: getCompanyHasHiddenBilling,
  isGlobalAdmin: getIsUserGlobalAdmin,
  isBilledThroughOtherCompany: getIsBilledThroughOtherCompany,
}));

export const SettingsAppsDetailsUpsellBannerContainer = connect(mapStateToProps)(
  SettingsAppsDetailsUpsellBanner,
);
